import React from "react";
import { motion } from "framer-motion";
import { BirthdayLink } from "@/components/BirthdayCaptureModal";

export const ZODIAC = [
  "aries", "taurus", "gemini", "cancer", "leo", "virgo",
  "libra", "scorpio", "sagittarius", "capricorn", "aquarius", "pisces",
];
export const ZODIAC_GLYPH = Object.fromEntries(
  Object.entries({
    aries: "♈", taurus: "♉", gemini: "♊", cancer: "♋", leo: "♌", virgo: "♍",
    libra: "♎", scorpio: "♏", sagittarius: "♐", capricorn: "♑", aquarius: "♒", pisces: "♓",
  }).map(([k, v]) => [k, v + "\uFE0E"]),
);

export const HoroscopePanel = ({ horoscope, activeSign, setActiveSign }) => {
  return (
    <aside id="horoscope-panel" data-testid="horoscope-view" className="bg-paper border border-[#e5e7eb] rounded-2xl p-6 shadow-sm">
      <div className="flex items-center gap-2 mb-5">
        <span className="text-gold text-base leading-none">★</span>
        <h3 className="text-[11px] font-bold tracking-[0.15em] uppercase text-ink">Your Daily Cosmos</h3>
      </div>

      <div className="grid grid-cols-4 gap-2.5 mb-6" data-testid="zodiac-grid">
        {ZODIAC.map((s) => {
          const active = activeSign === s;
          return (
            <button
              key={s}
              data-testid={`sign-${s}`}
              onClick={() => setActiveSign(s)}
              title={s}
              aria-pressed={active}
              className={active
                ? "h-14 rounded-xl bg-ink text-white border border-ink flex items-center justify-center text-[20px] font-medium"
                : "h-14 rounded-xl bg-white border border-[#e5e7eb] text-ink hover:border-gold flex items-center justify-center text-[20px] transition-colors"}
            >
              {ZODIAC_GLYPH[s]}
            </button>
          );
        })}
      </div>

      <div className="flex items-baseline justify-between mb-3">
        <h2 data-testid="active-sign-name" className="text-[28px] font-bold text-ink capitalize">{activeSign}</h2>
        {horoscope?.date && <span className="text-[12px] text-[#9ca3af]">{horoscope.date}</span>}
      </div>

      <motion.div
        key={activeSign}
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        data-testid="horoscope-text"
        className="bg-white border-l-4 border-gold rounded-xl p-5 text-[15px] leading-[1.7] text-[#333] shadow-sm"
      >
        {horoscope?.signs?.[activeSign] || "Loading the cosmos..."}
      </motion.div>

      <div className="mt-5 flex flex-col items-center gap-3">
        <BirthdayLink testid="horoscope-cta" label="Get My Full Birthday Reading →" source="daily_cosmos" />
        <BirthdayLink testid="birthday-link-cosmos" source="daily_cosmos" />
      </div>
    </aside>
  );
};
